import "./main.scss";
import { widgetInit } from "./init";

window.addEventListener("load", async function () {
  await widgetInit(window["DeliverectWidgetClient"]);
});
